module.exports = __webpack_public_path__ + "img/popup16.f46389ce.png";